import jwtDecode from "jwt-decode";
import http from "./httpService";
//import httpCustomer from "./httpServiceCustomer"; //2023-09-07

const apiEndpoint = "/auth";
const tokenKey = "token";

http.setJwt(getJwt());
//httpCustomer.setJwt(getJwt()); //2023-09-07

export async function login(email, password) {
  const { data: jwt } = await http.post(apiEndpoint, { email, password });
  //2023-03-17
  //localStorage.setItem(tokenKey, jwt);
  localStorage.setItem(tokenKey, jwt.token);
}

export function loginWithJwt(jwt) {
  localStorage.setItem(tokenKey, jwt);
}

export function logout() {
  localStorage.removeItem(tokenKey);
}

export function getCurrentUser() {
  try {
    const jwt = localStorage.getItem(tokenKey);
    return jwtDecode(jwt);
  } catch (ex) {
    return null;
  }
}

export function getJwt() {
  return localStorage.getItem(tokenKey);
}

export default {
  login,
  loginWithJwt,
  logout,
  getCurrentUser,
  getJwt,
};
